import { select, cancel, put, takeLeading } from 'redux-saga/effects';
import { SAGA_EJECTED, DAEMON } from '@dbh/redux-extra';
import { s as selectCancellableReduxSagaSpawnState, a as spawnedTasksCancelled, R as REDUX_AND_SAGA_KEY } from './index-e8f6e1a7.js';
import 'prop-types';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import { createSelector } from 'reselect';
import 'lodash/isEmpty';
import '@dbh/environment';
import '@reduxjs/toolkit';

/**
 * Returns a selector that returns `true` if the given saga has spawned cancellable
 * tasks.
 * @param {string} sagaName .
 * @return {boolean} .
 */const makeSelectHasSagaSpawnedCancellableTasks=withConformsTo("makeSelectHasSagaSpawnedCancellableTasks",[],a=>createSelector(selectCancellableReduxSagaSpawnState,b=>b.some(b=>{let{dependantSagaName:c}=b;return c===a})));var makeSelectHasSagaSpawnedCancellableTasks$1 = makeSelectHasSagaSpawnedCancellableTasks;

/**
 * @typedef {import('./types').SpawnedGeneratorsDataList} SpawnedGeneratorsDataList
 * @typedef {import('./types').GeneratorName} GeneratorName
 *//**
 * Returns a selector that returns a list of (cancellable) spawned generator data,
 * for the generator with the given name.
 * @return {Object<GeneratorName, SpawnedGeneratorsDataList>} .
 */const makeSelectSpawnedGeneratorsDataMap=()=>createSelector(selectCancellableReduxSagaSpawnState,a=>a.reduce((a,b)=>{const{spawnedGeneratorName:c}=b;return {...a,[c]:[...(a[c]||[]),b]}},{}));var makeSelectSpawnedGeneratorsDataMap$1 = makeSelectSpawnedGeneratorsDataMap;

/**
 * When a saga that spawned cancellable tasks is ejected, this function cancels
 * such tasks, only if there are no other active sagas dependent on them.
 * @param {Object} event .
 * @param {Object} event.payload .
 * @param {string} event.payload.key .
 * @param {string} event.type .
 */const handleSagaEjected=withConformsTo("handleSagaEjected",[],function*(a){const{payload:{key:b}}=a,c=yield select(makeSelectHasSagaSpawnedCancellableTasks$1(b));if(!c)return;const d=yield select(makeSelectSpawnedGeneratorsDataMap$1()),e=[];Object.values(d).forEach(a=>{const c=a.some(c=>{let{dependantSagaName:d}=c;return !!(d===b)&&1===a.length});if(c){const[{spawnedTask:b}]=a;e.push(b);}}),yield cancel(e),yield put(spawnedTasksCancelled({ejectedSagaName:b}));});var handleSagaEjected$1 = handleSagaEjected;

function*rootSaga(){// We don't use `takeLatest` because we don't want to cancel the running
// sagas, in order to finish updating the reducer state.
// @see {@link https://redux-saga.js.org/docs/api/#takeleadingpattern-saga-args}
yield takeLeading(SAGA_EJECTED,handleSagaEjected$1);}const injectedSagaConfiguration={key:REDUX_AND_SAGA_KEY,mode:DAEMON,saga:rootSaga};

export { rootSaga as default, injectedSagaConfiguration, rootSaga };
